import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getContentCountRequest, getContentCountRequestError, getContentCountRequestSuccess } from "../../slices/content-management/CountSlice";

export const GetContentCountAPI = () => async (dispatch) => {
    try {
        dispatch(getContentCountRequest());
        axiosInstance({
            method: "GET",
            url: endpoints.contentCount,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getContentCountRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getContentCountRequestError(_error));
            });
    } catch (error) { }
};
